export default `# Drelo — Política de Envíos (Borrador)

**Última actualización:** 23 de junio de 2026

## Cómo enviamos

Drelo opera bajo un modelo de **dropshipping**: tus productos se envían directamente desde nuestros centros de distribución internacionales (a través de nuestro proveedor, CJDropshipping) hasta tu dirección. No mantenemos inventario físico propio, por lo que los tiempos de envío son más largos que los de una tienda con almacén local.

## Tiempos estimados

- **Procesamiento del pedido:** 1-3 días hábiles antes de despacharse.
- **Tiempo de tránsito estimado:** 7 a 25 días hábiles, dependiendo del producto, el país de destino y la aduana local.
- Estos tiempos son estimados, no garantizados — pueden variar por demanda, festivos, o demoras aduanales fuera de nuestro control.

## Seguimiento

Una vez despachado tu pedido, recibirás un número de rastreo por correo electrónico cuando esté disponible.

## Aduanas e impuestos de importación

Dependiendo de tu país, tu pedido puede estar sujeto a impuestos de importación, aranceles o tasas aduanales adicionales al recibirlo, que son responsabilidad del comprador y no están incluidos en el precio mostrado en Drelo.

## Pedidos con múltiples productos

Si tu pedido incluye varios productos, pueden llegar en paquetes separados y en fechas distintas, ya que pueden despacharse desde distintos centros de distribución.

## Direcciones incorrectas

Es tu responsabilidad ingresar una dirección de envío correcta y completa. Drelo no se hace responsable por pedidos no entregados debido a una dirección incorrecta proporcionada por el cliente.

## Contacto

Si tu pedido excede el tiempo estimado de entrega, contáctanos en soporte@drelo.shop con tu número de orden.
`;
